const development = {
    environment: 'development',
    general : {
        apiUrl : process.env.VUE_APP_API_URL_DEV,
        secretKey : process.env.VUE_APP_SECRET_KEY_DEV
    },
    firebase : {
        apiKey: process.env.VUE_APP_FIREBASE_KEY_DEV,
        authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN_DEV,
        projectId: process.env.VUE_APP_FIREBASE_PROJECTID_DEV,
        storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET_DEV,
        messagingSenderId: process.env.VUE_APP_FIREBASE_SENDERID_DEV,
        appId: process.env.VUE_APP_FIREBASE_APPID_DEV,
        measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENTID_DEV,
        validApikey: process.env.VUE_APP_FIREBASE_VALIDAPIKEY_DEV,
        pushNotificationKey: process.env.VUE_APP_PUSHNOTIFICATIONKEY_DEV,
        pushNotificationEmail: process.env.VUE_APP_PUSHNOTIFICATIONEMAIL_DEV
    },
    sentry : {
        dsn : process.env.VUE_APP_SENTRY_DSN_DEV
    }
}
 
const staging = {
    environment: 'staging',
    general : {
        apiUrl : process.env.VUE_APP_API_URL_STAGING,
        secretKey : process.env.VUE_APP_SECRET_KEY_STAGING
    },
    firebase : {
        apiKey: process.env.VUE_APP_FIREBASE_KEY_STAGING,
        authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN_STAGING,
        projectId: process.env.VUE_APP_FIREBASE_PROJECTID_STAGING,
        storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET_STAGING,
        messagingSenderId: process.env.VUE_APP_FIREBASE_SENDERID_STAGING,
        appId: process.env.VUE_APP_FIREBASE_APPID_STAGING,
        measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENTID_STAGING,
        validApikey: process.env.VUE_APP_FIREBASE_VALIDAPIKEY_STAGING,
        pushNotificationKey: process.env.VUE_APP_PUSHNOTIFICATIONKEY_STAGING,
        pushNotificationEmail: process.env.VUE_APP_PUSHNOTIFICATIONEMAIL_STAGING
    },
    sentry : {
        dsn : process.env.VUE_APP_SENTRY_DSN_STAGING
    }
}


const production = {
    environment: 'production',
    general : {
        apiUrl : 'https://main-whitehouse.production.useswapto.com',
        secretKey : process.env.VUE_APP_SECRET_KEY_PROD
    },
    firebase : {
        apiKey: process.env.VUE_APP_FIREBASE_KEY_PROD,
        authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN_PROD,
        projectId: process.env.VUE_APP_FIREBASE_PROJECTID_PROD,
        storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET_PROD,
        messagingSenderId: process.env.VUE_APP_FIREBASE_SENDERID_PROD,
        appId: process.env.VUE_APP_FIREBASE_APPID_PROD,
        measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENTID_PROD,
        validApikey: process.env.VUE_APP_FIREBASE_VALIDAPIKEY_PROD,
        pushNotificationKey: process.env.VUE_APP_PUSHNOTIFICATIONKEY_PROD,
        pushNotificationEmail: process.env.VUE_APP_PUSHNOTIFICATIONEMAIL_PROD
    },
    sentry : {
        dsn : process.env.VUE_APP_SENTRY_DSN_PROD
    }
}


let config = undefined;

switch (process.env.NODE_ENV) {
  case development.environment:
    config = staging;
    break;
  case staging.environment:
    config = staging;
    break;
  case production.environment:
    config = production;
    break;
  default:
    config = development;
    break;
}

export default config;
